import getActionAttributeKeys from './getActionAttributeKeys';
import getValuesFromKey from './getValuesFromKey';
import isAttributeKeyCoveredByAction from './isAttributeKeyCoveredByAction';

const getDirectStepAttributes = ({ actionId, parentStepId, stepId, appId, steps, apps, output }) => {
  const step = steps?.find((n) => n?.id === stepId);
  const parentStep = steps?.find((n) => n?.id === parentStepId);
  const parentDataKey = parentStep?.arguments?.dataKey;
  const app = apps?.find((n) => n?.id === appId);
  const action = actionId ? app?.actions?.find((a) => a.id === actionId) : app?.actions?.find((a) => a.id === step?.actionId);
  const actionAttributes = action?.attributes || [];
  const stepAttributes = step?.meta?.attributes || [];

  const actionAttributeKeys = getActionAttributeKeys(actionAttributes);

  let merged = [...actionAttributes, ...stepAttributes.filter((attr) => !isAttributeKeyCoveredByAction(attr?.key, actionAttributeKeys))];

  if (parentDataKey) {
    merged = merged.filter((attr) => attr?.key?.startsWith(parentDataKey) && attr?.key !== `${parentDataKey}[]`).map((attr) => ({ ...attr, key: attr?.key?.replace(`${parentDataKey}[].`, '') }));
  }

  if (output) {
    const out = Array.isArray(output) ? output : output?.data;
    const mapped = merged.map((attr) => {
      const values = getValuesFromKey(out, attr.key);
      if (!values.length || values.some((v) => v === undefined || v === '' || typeof v === 'object')) {
        return attr;
      }
      return { ...attr, outputs: values };
    });

    if (mapped.length === 0 && out) {
      const sample = Array.isArray(out) ? out?.[0] : out;
      if (sample && typeof sample === 'object') {
        const fallback = Object.keys(sample || {}).map((key) => {
          const values = getValuesFromKey(out, key);
          return {
            key,
            dataType: Array.isArray(values) ? 'array' : typeof values?.[0],
            outputs: values
          };
        });
        return fallback;
      }
    }

    return mapped;
  }

  return merged;
};

export default getDirectStepAttributes;
